/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetProductionOrderFinishInfoEntry } from '../../models/set-production-order-finish-info-entry';

export interface SetProductionOrderFinishedInfo$Params {
  productionOrderId: number;
      body: SetProductionOrderFinishInfoEntry
}

export function setProductionOrderFinishedInfo(http: HttpClient, rootUrl: string, params: SetProductionOrderFinishedInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setProductionOrderFinishedInfo.PATH, 'post');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setProductionOrderFinishedInfo.PATH = '/api/v1/ProductionOrder/{productionOrderId}/SetFinishedInfos';
